import { useQuery } from "@tanstack/react-query";
import { getLectureItemVideo } from "../../../../services/dashboard/apiLecture";

export function useLectureItemVideo({ courseId, lectureId, videoId } = {}) {
  const { data: lectureVideo, isPending } = useQuery({
    queryKey: ["lectureVideoDashboard", courseId, lectureId, videoId],
    queryFn: () =>
      getLectureItemVideo({
        courseId,
        lectureId,
        videoId,
      }),
  });

  return { isPending, lectureVideo };
}
